import React from 'react';
import { classnames } from 'Utils/classnames/classnames.utils';
type Props = {
  className?: string;
  errorMessage?: string;
  errorNoteId?: string;
  isErrored: boolean;
};
export const ErrorNote = ({
  className,
  errorMessage,
  errorNoteId = 'error-note',
  isErrored = false,
}: Props) => (
  <div aria-live="assertive" className={classnames('text-12 text-red', className)} id={errorNoteId}>
    {isErrored && errorMessage && <p className="pb-10 pt-5">{errorMessage}</p>}
  </div>
);
